const DrawingToolbar = ({ drawingTool, onToolSelect, onClearAll }) => {
  return (
    <>
      <button
        className={`drawing-btn ${drawingTool === 'trend' ? 'active-drawing' : ''}`}
        onClick={() => onToolSelect('trend')}
        title="Trend Line"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <line x1="2" y1="14" x2="14" y2="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
      <button
        className={`drawing-btn ${drawingTool === 'horizontal' ? 'active-drawing' : ''}`}
        onClick={() => onToolSelect('horizontal')}
        title="Horizontal Line"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <line x1="1" y1="8" x2="15" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
      <button
        className={`drawing-btn ${drawingTool === 'measure' ? 'active-drawing' : ''}`}
        onClick={() => onToolSelect('measure')}
        title="Measure (click two points)"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="2" y="2" width="12" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <line x1="4" y1="12" x2="12" y2="4" stroke="currentColor" strokeWidth="1" strokeDasharray="2 2"/>
          <circle cx="4" cy="12" r="1.5" fill="#FF9800"/>
          <circle cx="12" cy="4" r="1.5" fill="#FF9800"/>
        </svg>
      </button>
      <div className="drawing-separator" />
      <button
        className="drawing-btn clear-btn"
        onClick={onClearAll}
        title="Clear All Drawings"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <line x1="1" y1="1" x2="13" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <line x1="13" y1="1" x2="1" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
    </>
  );
};

export default DrawingToolbar;
